export enum States {
  DEFAULT = 'DEFAULT',
  OK = 'OK',
  WARNING = 'WARNING',
  ERROR = 'ERROR'
}
